import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalStateService } from '@app/core/services/global-state.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AlertsActionService {
    public constructor(private httpClient: HttpClient, private globalStateService: GlobalStateService) {}

    private getBaseUrl(entityType: string, entityId: string): string {
        return environment.API_URL + `v3/users/${this.globalStateService.userId}/${entityType}/${entityId}`;
    }

    public deleteAlert(entityType: string, entityId: string): Observable<any> {
        const urlDelete: string = this.getBaseUrl(entityType, entityId);

        return this.httpClient.delete(urlDelete, {
            headers: new HttpHeaders({
                Authorization: `Bearer ${localStorage.getItem('access_token') ?? ''}`
            })
        });
    }
}
